import { render, staticRenderFns } from "./editCommunity.vue?vue&type=template&id=f8a37a42&scoped=true"
import script from "./editCommunity.vue?vue&type=script&lang=js"
export * from "./editCommunity.vue?vue&type=script&lang=js"
import style0 from "./editCommunity.vue?vue&type=style&index=0&id=f8a37a42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a37a42",
  null
  
)

export default component.exports